(function() {
	if ($('.section-bauchecker').length) {
		const $baucheckerForm = $('#bauchecker-form');
		const $filterValueSpans = $baucheckerForm.find('.filter-value-span');
		const $baucheckerFormSelected = $('#baucheckerFormSelected');
		const $baucheckerResults = $('.section-bauchecker .section-listing .list');

		$filterValueSpans.on('click', function () {
			$filterValueSpans.removeClass('active'); // Remove active class from all spans
			$(this).addClass('active'); // Add active class to clicked span
			$baucheckerFormSelected.val($(this).attr('data-value')); // Update hidden input value
			$.ajax({
				url: $baucheckerForm.attr('action'),
				type: 'POST',
				data: $baucheckerForm.serialize(),
				success: function (response) {
					$baucheckerResults.html(response);
				},
			});
		});
	}

	function resizeAnimatedText() {
		if ($('.bauchecker-container').length) {
			$('.bauchecker-container').each(function() {
				decreaseFontSize($(this));
			});
		}
		if ($('.section-teaser-video').length) {
			$('.section-teaser-video').each(function() {
				decreaseFontSize($(this));
			});
		}
	}
	function decreaseFontSize(container){
		container.removeAttr('style');
		var needsResize = 0;
		var textLines = container.find('.animeted-text-holder span');

		textLines.each(function() {
			if (countLines($(this)) > 1) {
				needsResize = 1
			}
		});
		if (needsResize) {
			textLines.each(function() {
				let newFontSize = parseInt($(this).css('font-size'));
				newFontSize = parseInt(newFontSize -1);
				$(this).css('font-size', newFontSize+'px');
			});
			decreaseFontSize(container);
		}
	}

	function countLines(element) {
		var elementHeight = element.height();
		var lineHeight = parseInt(element.css('line-height'));
		var lines = parseInt(elementHeight / lineHeight);
		return lines;
	}
	$(window).on( "resize", resizeAnimatedText);
	resizeAnimatedText();
})();
